import { instancePerContainerCachingFactory, registry } from 'tsyringe';
import { SubGameHandler, kNameOfSubGameHandler } from './sub-game-handler';
import { RobloxSubGameHandler } from './roblox-sub-game-handler';

// -----------------------------------------------------------------------------
// Registers every SubGameHandler under kNameOfSubGameHandler so that
// SubGameHandlerRegistry can pick them up via @injectAll. Add new handlers
// here as new games are supported.
@registry([
  // ---------------------------------------------------------------------------
  {
    token: kNameOfSubGameHandler,
    useFactory: instancePerContainerCachingFactory<SubGameHandler>((c) => {
      return c.resolve(RobloxSubGameHandler);
    }),
  },
])
export class SubGameHandlersRegistry {}
